// ==========================================
// Resize
// Dynamically add responsive event handlers
// @use resize.addResponsiveHandler(module.handler);
// ==========================================

import $ from 'jquery'

export let winWidth = $(window).width();
export let winHeight = $(window).height();

export let resize = {

  init() {
    resize.addResponsiveHandler(resize.updateWindowSize);
    resize.updateWindowSize();
  },

  updateWindowSize() {
    winWidth = $(window).width();
    winHeight = $(window).height();
  },

  addResponsiveHandler(handler) {
    let throttleBy = 100;
    let delay = (function(){
      let resizeTimer;
      return function(callback, ms){
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(callback, ms);
      };
    })();

    $(window).on("resize", function() {
      delay(handler, throttleBy );
    });
  }

};


